import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseAutoCompleteWithSingleSelectedItem from '@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue';
import FirmwareVersionsType from '@/types/FirmwareVersionsType';
import { onMounted, ref, computed } from 'vue';
import Api from '@/services/api/ApiServiceFabrick';


export default /*@__PURE__*/_defineComponent({
  __name: 'FirmwareVersionAutoComplete',
  props: {
    modelValue: {},
    initialItemId: {},
    errorMessages: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const items = ref<FirmwareVersionsType[]>([]);

onMounted(() => {
  Api()
    .autoCompleteFirmwaresVersions()
    .then((data) => {
      items.value = data;
    });
});

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseAutoCompleteWithSingleSelectedItem, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    label: "バージョン",
    itemName: "name",
    items: items.value,
    "initial-item-id": props.initialItemId,
    "error-messages": __props.errorMessages
  }, null, 8, ["modelValue", "items", "initial-item-id", "error-messages"]))
}
}

})